module.exports = __webpack_public_path__ + "img/logo-orange-yellow.998b5071.png";